import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, NEVER, Observable, throwError } from 'rxjs';

// COUPLING: this path and the `503 { error: 'maintenance' }` contract checked
// in isMaintenanceResponse below are mirrored on the server at
// server/src/loaders/maintenance.middleware.js (MAINTENANCE_PAGE_PATH + the
// 503 JSON response). The page itself lives at web/src/assets/maintenance.html.
// Changing any of the three — the asset path, the status code, or the error
// body shape — requires updating all of them together, or this interceptor will
// stop recognising the maintenance response and the redirect will 404.
export const MAINTENANCE_PAGE_PATH = '/assets/maintenance.html';

const isMaintenanceResponse = (err: unknown): boolean => {
  if (!(err instanceof HttpErrorResponse)) {
    return false;
  }
  if (err.status !== HttpStatusCode.ServiceUnavailable) {
    return false;
  }
  return err.error?.error === 'maintenance';
};

// When the Collector is in maintenance mode the API answers with 503
// { error: 'maintenance' }. Any such response sends the SPA to the static
// maintenance page so the app never tries to keep running against an offline
// backend (works on the dev server and in production alike).
@Injectable()
export class MaintenanceInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((err) => {
        if (isMaintenanceResponse(err)) {
          window.location.replace(MAINTENANCE_PAGE_PATH);
          return NEVER;
        }
        return throwError(() => err);
      })
    );
  }
}
